<template>
    <div id="deviceInfo">
        <div v-if="latestDevices" class="card dashboardWidget">
            <div class="card-header">
                <h2>Latest Devices</h2>
            </div>
            <div class="card-body">
                <dx-data-grid id="gridContainer" :data-source="latestDevices" :show-borders="true" key-expr="Id" :allow-column-reordering="true"
                              :allow-column-resizing="true"  >

                    <dx-state-storing :enabled="true" type="localStorage" storage-key="lastestDevices" />
                    <dx-paging :enabled="false" />
                    <dx-editing :use-icons="true" />
                    <dx-scrolling mode="infinite" :scrollByThumb="true"/>

                    <dx-column :width="50" icon="save" :buttons="onClickDevice" type="buttons" />
                    <dx-column data-field="Updated" caption="Updated" data-type="datetime" :customizeText="toLocalTime" />
                    <dx-column data-field="SerialNumber" caption="Serial Number" />
                    <dx-column data-field="Manufacturer" caption="Manufacturer" />
                    <dx-column data-field="Model" caption="Model" />

                </dx-data-grid>
            </div>


            <div v-if="latestDevices" class="card-footer text-center text-muted ">
                <!--<p>Number of Latest Devices: {{this.latestDevices.length}}</p>-->
            </div>
        </div>
        
        
    </div>
    
</template>
<script>
    import LoadingAnimation from '@/components/general/LoadingAnimation.vue'
    import {
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxPaging,
        DxScrolling,
        DxColumFixing,
        DxStateStoring
    } from 'devextreme-vue/data-grid';


    export default {
        props: {
            latestDevices: {
                type: Array,
                default: () => { }
            }
        },
        components: {
            LoadingAnimation,
            DxColumn,
            DxDataGrid,
            DxEditing,
            DxPaging,
            DxScrolling,
            DxColumFixing,
            DxStateStoring
        },
        data: function () {
            return {
                onClickDevice: ['info', {
                    hint: "Device Details",
                    icon: 'fas fa-info-circle',
                    onClick: this.iconClick
                }]
            }
        },
        methods: {
            iconClick(devices) {
                //onclick of info icson pushes to path along with id from what was clicked
                window.location.href = '/dice/devices/' + devices.row.data.Id
            },
            toLocalTime(e) {

                return e.value = new Date(e.value).toLocaleString();
            }
        },
    }
</script>

<style scoped>
    #gridContainer {
        height: 254px;
    }

    .dx-link dx-icon fas fa-info-circle {
        height: 1px;
        width: 1px;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 1.5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    .dashboardWidget {
        padding-bottom: 2.25rem;
    }
</style>